import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import PayPalPayment from '../PayPalPayment';

const BuyerListPurchaseModal = ({
  open, onOpenChange, purchasingEventId, listPricing, formatPrice,
  createExhibitorListOrder, captureExhibitorListOrder, t,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('dashboard.purchase_exhibitor_list')}</DialogTitle>
          <DialogDescription>{t('dashboard.download_list_desc')}</DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <div className="bg-slate-50 rounded-lg p-4 mb-4">
            <p className="text-sm text-slate-600">Event: <span className="font-medium">{listPricing[purchasingEventId]?.event_name}</span></p>
            <p className="text-sm text-slate-600">Exhibitors: {listPricing[purchasingEventId]?.exhibitor_count || 0}</p>
            <p className="text-lg font-bold mt-2">{t('dashboard.price_label')} {formatPrice(listPricing[purchasingEventId]?.exhibitor_list_price)}</p>
          </div>
          <PayPalPayment amount={listPricing[purchasingEventId]?.exhibitor_list_price || 0}
            onApprove={async (data) => { await captureExhibitorListOrder(data.orderID); }} createOrder={createExhibitorListOrder} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BuyerListPurchaseModal;
